import { defineGameCard } from '../authoring/index.js';
export const SlimeDropletCard = defineGameCard({
    id: 'slime_droplet',
    gameplay: { type: 'UNIT', cost: 0, baseStats: { attack: 1, health: 1 }, traits: ['SLIME'] },
    presentation: {
        name: 'Капля',
        description: 'Токен-слизень 1/1. След 0.',
        glyph: {
            colors: ['#10213A', '#74AD4C', '#5E984F', '#96C653', '#3A624D'],
            rows: [
                '....................',
                '....................',
                '....................',
                '.........11.........',
                '........1231........',
                '........1431........',
                '.......132351.......',
                '......13222351......',
                '.....1244222331.....',
                '....152422223351....',
                '....152222223351....',
                '....152222233351....',
                '.....1333333551.....',
                '.....1553335551.....',
                '....111155551111....',
                '...12223111155221...',
                '...14422555554421...',
                '....111133311111....',
                '........111.........',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['token', 'trail', 'slime_residue'] },
});
//# sourceMappingURL=slime_droplet.js.map